import { Flex, Text } from "@chakra-ui/react"
import Icon from "components/elements/Icon"
import React from "react"

type Props = {
  status: 0 | 1 | 2 | 3
  statuses: string[]
}

const GuestStatus = ({ status, statuses }: Props) => {
  const statusColors = ["gray.500", "green.500", "red.500", "orange.300"]
  const statusNames = ["unconfirmed", "confirmed", "declined", "waitlisted"]

  return (
    <Flex mb={1} color={statusColors[status]} alignItems="center">
      <Icon icon={`portal-${statusNames[status]}`} mr={1} />
      <Text textTransform="uppercase" fontSize="md" fontWeight="bold">
        {statuses[status]}
      </Text>
    </Flex>
  )
}

export default GuestStatus
